// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-component-container {
  display: flex;
  align-items: center;
  background: var(--input-text-container-background);
  border-radius: var(--input-text-border-radius);
  width: unset;
}
.v-component-container input {
  background: var(--input-text-background) !important;
  border: var(--input-text-border) !important;
  border-radius: var(--input-text-border-radius) !important;
  font-size: var(--input-text-font-size) !important;
  color: var(--input-text-color) !important;
}
.v-component-container input:hover {
  border-color: var(--input-text-border-hover-color) !important;
}
.v-component-container.full {
  width: var(--input-text-width-full);
}
.v-component-container.prefixed input {
  border-top-left-radius: var(--input-text-border-top-left-radius);
  border-bottom-left-radius: var(--input-text-border-bottom-left-radius);
}
.v-component-container.suffixed input {
  border-top-right-radius: var(--input-text-border-top-right-radius);
  border-bottom-right-radius: var(--input-text-border-bottom-right-radius);
}

.affix {
  padding: var(--input-text-padding);
  text-wrap: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.input {
  position: relative;
  display: grid;
  width: var(--input-text-width-full);
  height: var(--input-text-height-full);
}

.length {
  position: absolute;
  top: var(--input-text-top);
  right: var(--input-text-right);
  font-size: var(--input-text-length-font-size);
  color: var(--input-text-color-length);
}

.size-small {
  width: var(--input-text-width-small) !important;
}
.size-medium {
  width: var(--input-text-width-medium) !important;
}
.size-large {
  width: var(--input-text-width-large) !important;
}
.size-full {
  width: var(--input-text-width-full) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/input-text/input-text.component.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,kDAAA;EACA,8CAAA;EACA,YAAA;AACJ;AAAI;EACI,mDAAA;EACA,2CAAA;EACA,yDAAA;EACA,iDAAA;EACA,yCAAA;AAER;AADQ;EACI,6DAAA;AAGZ;AADI;EACI,mCAAA;AAGR;AADQ;EACI,gEAAA;EACA,sEAAA;AAGZ;AADQ;EACI,kEAAA;EACA,wEAAA;AAGZ;;AAFA;EACI,kCAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;AAKJ;;AAHA;EACI,kBAAA;EACA,aAAA;EACA,mCAAA;EACA,qCAAA;AAMJ;;AALA;EACI,kBAAA;EACA,0BAAA;EACA,8BAAA;EACA,6CAAA;EACA,qCAAA;AAQJ;;AALI;EACI,+CAAA;AAQR;AAPI;EACI,gDAAA;AASR;AARI;EACI,+CAAA;AAUR;AATI;EACI,8CAAA;AAWR","sourcesContent":[".v-component-container\n    display: flex\n    align-items: center\n    background: var(--input-text-container-background)\n    border-radius: var(--input-text-border-radius)\n    width: unset\n    input\n        background: var(--input-text-background) !important\n        border: var(--input-text-border) !important\n        border-radius: var(--input-text-border-radius) !important\n        font-size: var(--input-text-font-size) !important\n        color: var(--input-text-color) !important\n        &:hover\n            border-color: var(--input-text-border-hover-color) !important\n\n    &.full\n        width: var(--input-text-width-full)\n    &.prefixed \n        input\n            border-top-left-radius: var(--input-text-border-top-left-radius)\n            border-bottom-left-radius: var(--input-text-border-bottom-left-radius)\n    &.suffixed \n        input\n            border-top-right-radius: var(--input-text-border-top-right-radius)\n            border-bottom-right-radius: var(--input-text-border-bottom-right-radius)\n.affix\n    padding: var(--input-text-padding)\n    text-wrap: nowrap\n    user-select: none\n    \n.input\n    position: relative\n    display: grid\n    width: var(--input-text-width-full)\n    height: var(--input-text-height-full)\n.length\n    position: absolute\n    top: var(--input-text-top)\n    right: var(--input-text-right)\n    font-size: var(--input-text-length-font-size)\n    color: var(--input-text-color-length)\n\n.size-\n    &small\n        width: var(--input-text-width-small) !important\n    &medium\n        width: var(--input-text-width-medium) !important\n    &large\n        width: var(--input-text-width-large) !important\n    &full\n        width: var(--input-text-width-full) !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
